// TODO might use 'crm_schema/constants/ObjectTypes' instead, by taking a subset of that.
const PropertyValueTypes = {
  DATE: 'date',
  DATETIME: 'datetime',
  NUMBER: 'number',
  STRING: 'string',
  ENUM: 'enumeration',
  BOOL: 'bool',
  PHONE_NUMBER: 'phone_number',
  UNKNOWN: 'unknown'
};
export default PropertyValueTypes;
export const PropertyValueTypeList = Object.values(PropertyValueTypes);